const CourseDetailsLoading = () => {
    return (
        <div>
            <div className="h-10 w-full l-load mb-3"></div>
            <div className="py-7 px-20 grid grid-cols-[67%_33%] gap-8 max-lg:grid-cols-1 max-lg:px-2">
                <div className="w-full h-full">
                    <div className="flex justify-between items-center p-2 max-md:flex-col max-md:items-start max-md:gap-4">
                        <div>
                            <div className="w-56 h-4 l-load-dt rounded-md"></div>
                            <div className="w-40 mt-1 h-4 l-load-dt rounded-md"></div>
                        </div>
                        <div className="flex gap-2 items-center">
                            <div className="w-24 rounded-md h-7 l-load-dt"></div>
                            <div className="w-24 rounded-md h-7 l-load-dt"></div>
                        </div>
                    </div>
                    <div className="w-full rounded-lg h-[30rem] max-lg:h-[20rem] l-load"></div>
                </div>
                <div>
                    <div className="border-2 border-secondary-tw p-3 rounded-lg h-fit">
                        {
                            [...Array(5)].map((_, i) => (
                                <div className="flex gap-2 items-center mb-2" key={i}>
                                    <div className="size-14 rounded-full l-load-dt"></div>
                                    <div className="w-44 h-3 l-load-dt"></div>
                                </div>
                            ))
                        }
                    </div>
                    <div className="border-2 mt-2 border-secondary-tw p-3 rounded-lg h-fit w-full flex gap-4">
                        <div className="size-28 rounded-md l-load-dt"></div>
                        <div className="space-y-2 flex-col" style={{ display: 'flex' }}>
                            <div className="w-32 h-3 l-load-dt"></div>
                            <div className="w-48 h-3 l-load-dt"></div>
                            <div className="w-36 h-3 l-load-dt"></div>
                            <div className="w-28 h-3 l-load-dt"></div>
                        </div>
                    </div>
                    <div className="w-full h-12 rounded-lg l-load mt-2"></div>
                </div>
            </div>
        </div>
    )
};
export default CourseDetailsLoading